$(document).on('keypress', 'input[name=donationAmount],input[name=amount]', function (event) {
    if (String.fromCharCode(event.which) === ',') {
        return false;
    }
});
